// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1A7oh","paramInput":"JobSimulator_paramInput__1hkZT","input":"JobSimulator_input__rf27I"};